module.exports = __webpack_public_path__ + "img/icon-pickup.c26a7bd1.png";